<template>
  <div>
    <div class="account-confirm">
      <div class="grayHead">
        <span>
          アカウントが更新されました
        </span>
      </div>
      <div class="account-confirm__btnWrapper">
        <Btn
          :label="'戻る'"
          :color="'red'"
          class="edit-btn"
          @click.native="back"
        />
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import redirect from '@/mixin/redirect.mixin'
import Btn from '@/components/parts/Btn'

export default {
  name: 'AccountEditStep03Complete',

  mixins: [redirect],

  components: {
    Btn
  },

  beforeRouteEnter (from, to, next) {
    store.commit('loadingAction', false)
    next()
  },

  methods: {
    back () {
      this.goToEcSite()
    }
  }
}
</script>

<style lang="postcss" scoped>

  .account-confirm {
    height: 100%;
    overflow: auto;

    &__btnWrapper {
      margin: 100px auto 40px;
      padding: 0 15px;
      max-width: 600px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/account-edit/Step03Complete.vue